import React, { useState } from 'react';
//import programdata from '../programdata/db.json';
// rrd import
import { useLoaderData } from 'react-router-dom';

// component import
import Footer from '../components/Footer';
import ProgramDetailsView from '../components/ProgramDetailsView';

const UndergraduatePrograms = () => {
    const programs = useLoaderData();
    console.log("Data:", programs);
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className='course-programs'>
      <h2 className='u-title'>Programs we offer</h2>

      {programs.undergraduatePrograms.map(program => (
        <div className="pro-link" key={program.id}>
          <div
            className="pro-summary"
            onClick={() => setExpandedId(expandedId === program.id ? null : program.id)}
            style={{ cursor: 'pointer' }}
          >
            <p>{program.program}</p>
            <p><b>Duration</b>: {program.duration}</p>
          </div>

          {expandedId === program.id && (
            <ProgramDetailsView program={program} />
          )}
        </div>
      ))}

      <Footer />
    </div>
  )
}

export default UndergraduatePrograms

// loader function
export const programsLoader = async () => {
    //const res = await fetch('http://localhost:3000/undergraduatePrograms');
    //const res = programdata;
    //if (!res.ok) {
     //   throw Error("Could not fetch programs");
    //}
    //return programdata;
    //res.json();
    const res = await fetch('/programdata/db.json');

  if (!res.ok) {
    throw Error("Could not fetch programs");
  }

  return await res.json();
}
